<template>
    <div class="relative w-full flex flex-col overflow-hidden" ref="viewer_page" style="height: 100vh;">
        <ViewerHeader
          :showLayerToolStatuses="showLayerToolStatuses"
          :actions="actionsHeader"
          :isViewingOperationalStatuses="isViewingOperationalStatuses"
          @epc-open-panel="_HandleOpenPanel"
          @epc-click-info="_HandleClickInfoPictogram"
          @epc-click-return="_HandleReturnClick"
        />

        <div class="relative w-full flex flex-1 min-h-0">

          <ViewerPanelViews v-if="showPanelViews"
              :views="pictogramLayers ? pictogramLayers : []"
              :workLayer="workLayer"
              :displayView="displayPictogramLayer"
              @epc-view-selected="_OnClickDisplayLayerPictogram"
              @epc-close="(e) => { showPanelViews = !e }"/>

          <div class="relative w-full flex overflow-hidden min-h-0">

            <KonvaViewer v-if="pictogram && pictogramLayers.length > 0 && workingPictogramLayer" ref="viewer" :key="componentViewerKey"
              :pictogram-id="pictogramId"
              :pictogram-type="pictogram.type"
              :pictogram-layers="pictogramLayers"
              :pictogram-design="pictogramDesign"
              :working-pictogram-layer="workingPictogramLayer"
              :cad-layers-design="cadLayerDesign"
              :fonts="fonts"
              :workLayer="workLayer"
              :canActionsPictogram="canActionsPictogram"
              :show-layer-completed="showLayerCompleted"
              :type-register="typeRegister"
              @epc-loaded="_OnLoaded"
              @epc-loaded-scene="_OnLoadedScene"
              @epc-mounted="_OnMounted"
              @epc-cleared="_OnCleared"
              @epc-message="_OnMessage"
              @epc-pointerdown="_onPointerDown"
              @epc-changestatuses="_OnShowChangeStatuses"
              @epc-open-split="_OnShowFormSplit"
              @epc-isloading="(e) => { isLoading = e }"
              @epc-reload="() => { $emit('epc-reload') }"
              @epc-saving="(e) => { updateSpinnerLoader(e.loading, e.text) }"
              @epc-screenshot="(e) => { screenshot = e }"
              @epc-geo-reference-changed="_OnGeoReferenceChanged"
            />

          </div>

          <ViewerPanelScreenshot v-if="showPanelScreenshot"
            ref="refScreenshot"
            :views="pictogramLayers ? pictogramLayers : []"
            :workLayer="displayPictogramLayer"
            :screenshot="screenshot"
            @epc-view-selected="_OnClickDisplayLayerPictogram"
            @epc-close="(e) => { showPanelScreenshot = !e }"/>

          <ViewerPanelComments v-if="false"
            :views="pictogramLayers ? pictogramLayers : []"
            :workLayer="workLayer"
            :screenshot="screenshot"
            @epc-view-selected="_OnClickDisplayLayerPictogram"
            @epc-close="(e) => { showPanelViews = !e }"/>

          <LayersToolStatuses v-show="showLayerToolStatuses"
            :selected-entities="selectedEntities"
            :statuses="statuses"
            :incident-statuses="incidentStatuses"
            :allowed-statuses="allowedStatuses"
            :cad_layers_design="cadLayerDesign"
            :type-register="typeRegister"
            @epc-konva-changestatus="_HandleChangeStatus"
            @epc-close="(close) => showLayerToolStatuses = !close" />

          <LayersListKonva v-show="showLayerPanel"
            :layers="filterLayers"
            @toggleLayer="_OnToggleLayer"
            @toggleAll="_OnToggleAll"
            @epc-close="(close) => showLayerPanel = !close"/>

          <IncidentsListStatuses v-show="showInidentsPanel"
            :statuses="filterIncidentsStatuses"
            @toggleIncident="_OnToggleIncidetStatus"
            @toggleAllIncident="_OnToggleAllIncident"
            @epc-close="(close) => showInidentsPanel = !close"/>

          <LayersToolSplit v-show="showLayerToolSplit"
            :selected-entities="selectedEntities"
            :statuses="statuses"
            @epc-konva-split="handleSplitEntities"
            @epc-close="(close) => showLayerToolSplit = !close" />

        </div>

        <ViewerFooter
          :name_vista="name_vista"
          :actions="actionsFooter"
          :displayPictogramLayer="displayPictogramLayer"
          :isDraggable="isDraggable"
          :isSelecting="isSelecting"
          :selectedCount="selectedEntities.length"
          :viewOnly="_AllowedAction('view_only')"
          :geoReferenceConfigured="geoReferenceConfigured"
          :showGoogleMaps="showGoogleMaps"
          @epc-click-show-completion="(e) => showLayerCompleted = e"
          @epc-click-pan="_OnClickPan"
          @epc-click-fit="_OnFitContent"
          @epc-click-zoom-in="_OnClickZoom"
          @epc-click-zoom-out="_OnClickZoom"
          @epc-click-selecting="_OnClickSelecting"
          @epc-click-unselect="_OnClickUnselect"
          @epc-click-fullscreen="_OnClickFullScreen"
          @epc-click-save="_HandleClickSave"
          @epc-click-register="_HandleClickRegisterAdvance"
          @epc-click-toggle-map="_OnClickToggleMap"
        />

        <div class="docking-panel layers-panel" style="display: none;">
          <div class="docking-panel-title docking-panel-delimiter-shadow">Capas</div>
          <div class="docking-panel-close"></div>
          <div class="docking-panel-footer">
            <div class="docking-panel-footer-resizer"></div>
          </div>
        </div>

        <ViewerSpinnerLoader ref="refSpinnerLoader" :is-loading="isLoading" :custom-loader-text="customLoaderText"/>

        <InfoModal ref="refInfoModal" />

        <UpdateStatusesModal ref="refUpdateStatusesModal"
          @epc-update-selected-status="bulkUpdateStatus"
        />
    </div>

</template>

<script>
import KonvaViewer from "./KonvaViewer"
import Vue from "vue"
import mainFont from "../cad/assets/fonts/Roboto-LightItalic.ttf"
import aux1Font from "../cad/assets/fonts/NotoSansDisplay-SemiCondensedLightItalic.ttf"
import aux2Font from "../cad/assets/fonts/HanaMinA.ttf"
import aux3Font from "../cad/assets/fonts/NanumGothic-Regular.ttf"
import LayersListKonva from "./LayersListKonva"
import LayersToolStatuses from "./LayersToolStatuses.vue"
import LayersToolSplit from "./LayersToolSplit.vue"
import ViewerHeader from "./ViewerHeader.vue"
import ViewerFooter from "./ViewerFooter.vue"
import ViewerPanelViews from "./ViewerPanelViews.vue"
import ViewerPanelComments from "./ViewerPanelComments.vue"
import ViewerSpinnerLoader from "./ViewerSpinnerLoader.vue"
import ViewerPanelScreenshot from "./ViewerPanelScreenshot.vue"
import InfoModal from "./Info-modal.vue"
import IncidentsListStatuses from "./IncidentsListStatuses.vue"
import UpdateStatusesModal from "./components/modals/UpdateStatusesModal.vue"

import { getPictogram, getPictogramLayers, getPictogramDesign } from "./services/pictograms.services"
import { getPictogramLayerStatuses } from "./services/pictogram-layers.services"
import { isFullScreenSupported, requestFullScreen, exitFullScreen } from "@pictograms/shared/helpers/ui.helpers"
import { extractDataEntities, reversePictogramEntities } from "./services/viewer-entities.service"

export default {
    name: "ViewerPageKonva",
    components: {
    KonvaViewer,
    LayersListKonva,
    LayersToolStatuses,
    LayersToolSplit,
    ViewerHeader,
    ViewerFooter,
    ViewerPanelViews,
    ViewerPanelComments,
    ViewerSpinnerLoader,
    ViewerPanelScreenshot,
    InfoModal,
    IncidentsListStatuses,
    UpdateStatusesModal
},

    props: {
      pictogramId: { type: Number, default: null },
      workLayer: { type: String, default: null },
      typeRegister: { type: String, default: 'progress' }, // Bandera usado para identificar si se ba a registrar progreso u incidencia
      canActionsPictogram: { type:Object, default() { return {} } } // acciones que se puede realizar sobre el pictograma por defecto ninguna
    },

    data() {
      return {
        layers: null,
        filterLayers: null,
        showLayerPanel: false,
        displayPictogramLayer: '', // capa actual del pictograma que se está visualizando
        displayDefaultPictogramLayer: null, // capa por defecto del pictograma a visualizar
        heightContainerKonva: '75',
        fullscreenEnabled: false, // si esta activo el modo full screen
        isDraggable: false,
        isSelecting: false,

        showInidentsPanel: false,
        filterIncidentsStatuses: [],

        showLayerToolStatuses: false,
        selectedEntities: [], // entidades seleccionadas para cambiar de estado enviado desde konvaviewer.vue
        statuses: [], // estados que se aplican en una capa enviado desde konvaviewer.vue
        incidentStatuses: [], // estados de incidencia que se aplican en una capa enviado desde konvaviewer.vue

        allowedProgressStatuses: [], // estados que se aplican en una capa enviado desde konvaviewer.vue
        allowedIncidentStatuses: [], // estados de incidencia que se aplican en una capa enviado desde konvaviewer.vue

        showLayerToolSplit: false,

        showPanelViews: false,
        showLayerCompleted: false, // visualiza una capa representando las estructuras que tienen estado completado por defecto false
        showPanelScreenshot: false, // bandera que indica si se muestra o no el panel de screenshots
        screenshot: null,


        isLoading: false, // Indica si esta visible el loader
        customLoaderText: null, // texto mostrado en el loader

        componentViewerKey: 'viewer-konva-' + Math.random().toString(36).substring(7),

        typeStatus: 'progress',

        isViewingOperationalStatuses: false, // indica si está en modo visualización de estados operacionales (incidencias)

        // nuevas variables para refactorizar el codigo que valdra luego ir eliminando lo que no se use
        activityId: null,
        subactivityId: null,
        pictogram: null, // pictograma obtenido desde la API
        pictogramLayers: [], // capas del pictograma obtenido desde la API
        pictogramDesign: null, // diseño del pictograma obtenido desde la API
        workingPictogramLayer: null, // capa del pictograma donde se esta trabajando
        cadLayerDesign: {}, // capa de diseño de la capa obtenida desde pictogram.metadata.cad_layer_desing
        allowedStatuses: {
          progress: [],
          incident: []
        }, // estados de progreso permitidos para el usuario
        allowedSelectMultiple: {
          progress: "single",
          incident: "single"
        }, // si se permite seleccionar múltiples estados de progreso o incidencia

        // Geolocalización
        geoReferenceConfigured: false, // indica si la geo-referencia está configurada
        showGoogleMaps: false, // indica si se está mostrando el mapa de Google
      }
    },

    computed: {

      actionsHeader() {
        return {
          showButtonReturn: !!(this.canActionsPictogram.showButtonReturn ?? true),
          showButtonInfo: !!(this.canActionsPictogram.showButtonInfo ?? true)
        }
      },

      // acciones que se mostraran en el footer
      actionsFooter() {
        const layer = this.workingPictogramLayer;

        return {
          fitToScreen: true,
          zoomIn: true,
          zoomOut: true,
          pan: true,
          select: true,
          unselect: true,
          fullscreen: true,
          save: true,
          showButtonCompletion: this.displayPictogramLayer === 'modules',
          registerProgress: !!this.allowedStatuses.progress?.length,
          registerIncident: !!this.allowedStatuses.incident?.length,
          assignValidationFlow: !!layer?.validation_flows,
        }
      },


      // uiSettings() {

      //   return {
      //     header: {

      //     },

      //     footer: {

      //     }
      //   }
      // },

      name_vista() {
        if (this.pictogramLayers && this.pictogramLayers.length > 0) {
          const layer = this.pictogramLayers.find((lyr) => { return lyr.code === this.displayPictogramLayer });
          return layer ? layer.name : null
        }
        return null
      },
    },

    watch: {
      displayPictogramLayer(newVal, oldVal) {
        this.showLayerCompleted = newVal == 'modules'
      },

      pictogramLayers(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          // Estableces capa a motrar por defecto
            this.SetLayerDisplay();
            this.getPermittedStatuses();
        }
      }
    },

    created() {
      this.fonts = [mainFont, aux1Font, aux2Font, aux3Font];

      this.readPictogram();
      this.readPictogramLayers();
      this.readPictogramDesign();
    },

    mounted() {

    },

    methods: {

      async readPictogram() {
        this.pictogram = await getPictogram(this.pictogramId);

        if( this.pictogram ) {
          const cad = this.pictogram.metadata.cad_layers_design;
          this.cadLayerDesign = (cad && !Array.isArray(cad)) ? cad : {};

          if (this.pictogram.activities[0].parent_id !== null) {
            this.activityId = this.pictogram.activities[0].parent_id;
            this.subactivityId = this.pictogram.activities[0].id;
          } else {
            this.activityId = this.pictogram.activities[0].id;
            this.subactivityId = null;
          }

          // Actualizamos el título de la página
          const pageInfo = {
              title: this.$t('pictogram') + `: ${this.pictogram.name}`,
              subtitle: `${this.pictogram.activities[0].full_path_with_current}`,
              menuOption: this.$options.menuOption
            }
            this.$store.dispatch('app/updatePageInfo', { info: pageInfo })
        }
      },

      async readPictogramLayers() {
        const response = await getPictogramLayers(this.pictogramId);
        if( response.success ) {
          this.pictogramLayers = response.layers;
        } else {
          this.$toast.open({
            message: response.message,
            type: "is-danger",
            position: "is-top-right"
          });
        }
      },

      async readPictogramDesign() {
        try {
          const response = await getPictogramDesign(this.pictogramId);
          if( response.success ) {
            this.pictogramDesign = response.pictogramDesign;
            this._activateGeoReference();
          } else {
            this.$toast.open({
              message: response.message,
              type: "is-danger",
              position: "is-top-right"
            });
          }
        } catch (error) {
          console.error("Error al obtener el diseño del pictograma:", error);
          this.$toast.open({
            message: error.error_msg || this.$t("error_getting_pictogram_design"),
            type: "is-danger",
            position: "is-top-right"
          });
        }
      },

      updateSpinnerLoader(status, message) {
        this.isLoading = status;
        this.customLoaderText = message
      },

      async getPermittedStatuses() {
        this.allowedStatuses.progress = [];
        this.allowedStatuses.incident = [];

        if( this.workingPictogramLayer ) {
          const params = {
            with_permitted_statuses: 1,
          }
          const response = await getPictogramLayerStatuses(this.workingPictogramLayer.id, params);
          if( response.success ) {
            this.allowedStatuses.progress = response.data.statusesProgress ?? [];
            this.allowedStatuses.incident = response.data.statusesIncidents ?? [];
          } else {
            this.$toast.open({
              message: response.message,
              type: "is-danger",
              position: "is-top-right"
            });
          }
        }
      },

      bulkUpdateStatus(e) {
        // Acciones que requieren reversión/limpieza del historial
        const bulkActions = ['revert', 'clear'];
        const ACTION_MESSAGES = {
            revert: "Restaurando estados anteriores en las entidades seleccionadas...",
            clear:  "Eliminando el historial de estados de las entidades seleccionadas...",
            reset:  "Reiniciando ciclo de vida de las entidades seleccionadas..." // Por si la añades luego
        };

        if (bulkActions.includes(e.action)) {
          this.updateSpinnerLoader(true, ACTION_MESSAGES[e.action]);
          this.bulkActionEntities(e);
        } else {
          // e.action === 'register' u otras acciones
          // TDDO
          // aqui se debe realizar la logica para actualizar los estados de los elementos seleccionados
          // se debe realizar una llamada a la API para actualizar los estados de los elementos seleccionados

          // pero de momento mantenemos la logica antigua para no romper la funcionalidad actual.
          // console.log('UpdateStatusesModal -> bulkUpdateStatus: ', e)
          this.$refs.viewer.CompleteAction(e);
        }
      },

      async bulkActionEntities(e) {
        const selectedEntities = extractDataEntities(e.changeEntities) || [];

        try {
          const response = await reversePictogramEntities(this.pictogramId, e.action, e.typeStatus, selectedEntities, this.workLayer);

          if( response.success ) {

            const data = response.data;
            this.$refs.viewer.UpdateCurrentStatusEntities(data);

            this._OnClickUnselect();
            this.$toast.open({
              message: this.$t("assignment_update_success"),
              type: "is-success",
              position: "is-top-right",
            });

            this.$emit('epc-pictograms-reload')

          } else {
            this.$toast.open({
              message: response.error,
              type: "is-danger",
              position: "is-top-right",
            });
          }
        } catch (error) {
          console.error("Error al realizar accion masiba en las entidades seleccionadas:", error);
          this.processingData = false
          this.$toast.open({
            message: error.error_msg || this.$t("assignment_update_error"),
            type: "is-danger",
            position: "is-top-right",
          });
        } finally {
          this.updateSpinnerLoader(false, null);
        }


        // let form = new FormData();
        // form.append('action', e.action);
        // form.append('typeStatus', e.typeStatus);
        // form.append('selected_entities', JSON.stringify(extractDataEntities(e.changeEntities)));
        // form.append('work_layer', this.workLayer);

        // const url = `/api/v2/pictogram/${this.pictogramId}/reverse-entities`

        // // Enviamos el form
        // return await axios.post(url, form)
        //   .then((response) => {
        //     let data = response.data

        //     if (data && data.success) {

        //       console.log('%cEPC-TACKER: '+ '%c entities actualizado correctamente.', 'background: #5577BB; color: #fff', 'color: #000')

        //       return data.data

        //     } else if(data && data.msg){

        //       this.$notify.error('no_access_permissions')

        //     } else {
        //       this.$notify.error('error_saving')
        //     }
        //   })
        //   .catch(error => {
        //     // Manejar errores aquí
        //     if (error.response) {
        //       // La solicitud fue hecha y el servidor respondió con un estado de error
        //       this.$notify.error(error.response.data.message)
        //       // console.log('Error de respuesta:', error.response.status, error.response.data);
        //       console.error('%cEPC-TACKER: '+ '%c Error de respuesta:', 'background: #5577BB; color: #fff', 'color: #000', error.response.status, error.response.data)
        //     } else if (error.request) {
        //       // La solicitud se realizó pero no se recibió respuesta del servidor
        //       this.$notify.error('No se recibió respuesta del servidor (E500)')
        //       console.error('%cEPC-TACKER: '+ '%c No se recibió respuesta del servidor', 'background: #5577BB; color: #fff', 'color: #000')
        //     } else {
        //       // Ocurrió un error antes de la solicitud, como una configuración incorrecta de Axios
        //       this.$notify.error('Error de configuración')
        //       console.error('%cEPC-TACKER: '+ '%c Error de configuración:', 'background: #5577BB; color: #fff', 'color: #000', error.message)
        //     }

        //     return null;
        //   })
        //   // .finally(() => {
          //   this.$emit('epc-saving', { loading: false, text: null })
          // })
      },


      // metodos antiguios que hay que ir eliminando si no se usan despues de la refactorizacion

      ShowLoader(data) {
        this.isLoading = data.loading;
        this.customLoaderText = data.text
      },

      ShowPanelScreenshot(show) {
        this.showPanelScreenshot = show
      },

      // Method que obtiene las capturas de las diferentes capas
      async GetScreenshotsLayers() {
        let screenshots = []
        for (const lyr of this.pictogram.layers) {
          this._OnClickDisplayLayerPictogram(lyr.code)
          // await this.sleep(3000) // enves de realizar el fit pausamos 1 segundo

          await this.$refs.viewer.FitToScreen()
          .then(result => {
            let img = this.$refs.refScreenshot.getScreenShot()
            screenshots.push({
              name: lyr.code + '.png',
              src: this.$refs.refScreenshot.Base64ToBlob(img.replace('data:image/png;base64,', ''), 'image/png')
            })
          })
          await this.sleep(500) // Por si las moscas esperamos 1/2 seg entre captura
        }

        return screenshots
      },

      _OnLoaded() {
          // const layers = this.$refs.viewer.GetLayers()
          // layers.forEach(lyr => Vue.set(lyr, "isVisible", true))
          // this.layers = layers
      },

      _OnLoadedScene() {
          const layers = this.$refs.viewer.GetLayers()
          layers.forEach(lyr => Vue.set(lyr, "isVisible", true))
          this.layers = layers

          this.$refs.viewer.ShowPicComplete(this.showLayerCompleted)
      },

      _OnMounted() {
        // this._FilterLayer()
        this._OnClickDisplayLayerPictogram(this.displayPictogramLayer)

        // Cargar estado inicial de geo-referencia
        if (this.$refs.viewer) {
          this.geoReferenceConfigured = this.$refs.viewer.geoReferenceConfigured;
        }
      },

      _FilterLayer() {
        // Primero filtramos a queyos que en el name layer tiene el prifijo el codigo del layer a visualizar
        // luego verificamos si esto devuelve un resultado, caso contrario se filtrar a aquellos que no contengan
        // EPC en el nombre

        let filterType = this.displayPictogramLayer.toUpperCase()
        this.filterLayers = this.layers.filter( (l) => l.name.indexOf(filterType) !== -1 )

        if( this.filterLayers.length == 0 )
          this.filterLayers = this.layers.filter( (l) => l.name.indexOf('EPC') === -1 )
      },

      _FilterIncidentStatuses() {
        // Primero filtramos aquellos que en el name layer tiene el prifijo el codigo del layer a visualizar
        // luego verificamos si esto devuelve un resultado, caso contrario se filtrar a aquellos que no contengan
        // EPC en el nombre

        // const filterType = this.displayPictogramLayer.toLowerCase()
        // const lyr = this.pictogram.layers.find( (l) => l.code.indexOf(filterType) !== -1 )

        this.filterIncidentsStatuses = this.workingPictogramLayer?.incident_statuses ?? []
        this.filterIncidentsStatuses.forEach(item => Vue.set(item, "isVisible", true))
      },

      _OnCleared() {
          this.layers = null
      },

      _OnToggleLayer(layer, newState) {
          layer.isVisible = newState
          this.$refs.viewer.ShowLayer(layer.name, newState)
      },

      _OnToggleIncidetStatus(status, newState) {
        status.isVisible = newState
        this.$refs.viewer.ShowIncident(status, newState)
      },

      _OnToggleAll(newState) {
          if (this.layers) {
              for (const layer of this.layers) {
                  if (layer.isVisible !== newState) {
                      this._OnToggleLayer(layer, newState)
                  }
              }
          }
      },

      _OnToggleAllIncident(newState) {
          if (this.layers) {
              for (const layer of this.layers) {
                  if (layer.isVisible !== newState) {
                      this._OnToggleLayer(layer, newState)
                  }
              }
          }
      },

      _OnMessage(e) {
          let type = "info"
          // switch (e.detail.level) {
          // case _DxfViewer.MessageLevel.WARN:
          //     type = "warning"
          //     break
          // case _DxfViewer.MessageLevel.ERROR:
          //     type = "negative"
          //     break
          // }
          // this.$q.notify({ type, message: e.detail.message })
      },

      _OnClickDisplayLayerPictogram(type) {
        if (type === this.displayPictogramLayer)
          this.displayPictogramLayer = this.displayDefaultPictogramLayer
        else
          this.displayPictogramLayer = type

        // mandamos a renderizar los layers filtrados por tipo
        this._FilterLayer()

        this._FilterIncidentStatuses()
        // mandamos a renderizar

        this.$refs.viewer.Render(this.displayPictogramLayer, this.pictogram.type)
      },

      _onPointerDown(e) {
        // console.log('_onPointerDown up: ', e.detail)
        this.$refs.viewer.GetViewer().ResaltarObject(e.detail.domEvent)
      },

      _OnClickZoom(zoomIn) {
        if( zoomIn )
          this.$refs.viewer.ZoomIn()
        else
          this.$refs.viewer.ZoomOut()
      },

      _OnClickSelecting() {
        this.isSelecting = !this.isSelecting
        this.isDraggable = false

        this.$refs.viewer.Dragging(false)
        this.$refs.viewer.Selecting(this.isSelecting, this.workLayer)
      },

      _OnClickUnselect() {
        this.isSelecting = false
        this.isDraggable = false

        this.$refs.viewer.Unselect()
      },

      // toggleFullscreen() {
      _OnClickFullScreen() {
        const element = this.$refs.viewer_page; // El elemento que deseas mostrar en pantalla completa
        // const element = this.$refs.viewer.$el; // El elemento que deseas mostrar en pantalla completa

        if (this.fullscreenEnabled) {
          exitFullScreen();
          this.heightContainerKonva = '75';
          this.fullscreenEnabled = false;
        } else {
          if (isFullScreenSupported()) {
            requestFullScreen(element);
            this.heightContainerKonva = '100'
            this.fullscreenEnabled = true;
          } else {
            this.$toast.open({
              message: this.$t('fullscreen_not_supported'),
              type: "is-danger",
              position: "is-top-right"
            });
          }
        }
      },

      _OnFitContent() {
        this.$refs.viewer.FitToScreen()
      },

      async _HandleClickSave() {
        await this.$refs.viewer.Save()

        this.componentViewerKey = 'viewer-konva-' + Math.random().toString(36).substring(7)
      },

      GetModifiedEntities() {
        return this.$refs.viewer.GetModifiedEntities()
      },

      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },

      SetLayerDisplay() {
        // TODO: de momento agarramos el primer layer, esto cambiar en el futuro para buscar algun atributo que indique
        // que se muestra por defecto
        if (this.pictogramLayers) {
          if (this.workLayer) {
            this.workingPictogramLayer = this.pictogramLayers.find((lyr) => { return lyr.code === this.workLayer });
            this.displayPictogramLayer = this.workLayer
          } else {
            this.workingPictogramLayer = this.pictogramLayers[0];
            this.displayPictogramLayer = this.workingPictogramLayer.code;
          }

          this.displayDefaultPictogramLayer = this.displayPictogramLayer

          this.allowedSelectMultiple.progress = this.workingPictogramLayer.metadata?.config?.statuses?.select_multiple?.progress ?? "single";
          this.allowedSelectMultiple.incident = this.workingPictogramLayer.metadata?.config?.statuses?.select_multiple?.incidents ?? "single";
        }
      },

      _GetIcon(layer) {
        return layer.icon ?? 'grip-horizontal' // 'images'
      },

      _OnClickPan() {
        this.isDraggable = !this.isDraggable
        this.isSelecting = false
        this.$refs.viewer.Dragging(this.isDraggable)
        this.$refs.viewer.Selecting(this.isSelecting)
      },

      /**
       * Alterna la visualización del mapa de Google
       */
      _OnClickToggleMap() {
        if (this.$refs.viewer) {
          this.$refs.viewer.toggleGoogleMaps();
          this.showGoogleMaps = this.$refs.viewer.showGoogleMaps;
        }
      },

      /**
       * Maneja el cambio de configuración de geo-referencia
       */
      _OnGeoReferenceChanged(configured) {
        this.geoReferenceConfigured = configured;
        if (!configured) {
          this.showGoogleMaps = false;
        }
      },

      _activateGeoReference() {
        this.showGoogleMaps = false;
        this.geoReferenceConfigured = false;

        if (this.pictogramDesign && this.pictogramDesign.georeferencing && this.pictogramDesign.georeferencing.active) {
          this.geoReferenceConfigured = true;
          this.showGoogleMaps = true;
        }
      },

      _OnShowChangeStatuses(e) {
        // TODO: De momenot comentamos este fragmento de codigo por que se ara por modal esperamoa
        // aque dicen para elimnar o modificar el componente
        // this.showLayerToolStatuses = e.selected_entities.length > 0 ?? false;
        this.selectedEntities = e.selected_entities
        // // this.statuses = e.statuses
        // // this.incidentStatuses = e.incident_statuses
        // this.statuses = e.permitted_progress_statuses
        // this.incidentStatuses = e.permitted_incident_statuses
      },

      _OnShowFormSplit(e) {
        this.showLayerToolSplit = e.show
        this.selectedEntities = e.selected_entities
      },

      _HandleChangeStatus(e) {
        // de momento una vez que cambia de estado solo completamos la acción pasando los datos a la variable que
        // contiene todos los elementos que han cambiado de estado (refierase a la estructura general no a la propiedad)

        this.$refs.viewer.CompleteAction(e)
      },

      handleSplitEntities(e) {
        this.$refs.viewer.SplitEntities(e)
      },

      _HandleOpenPanel(namePanel) {
        if (namePanel === 'panel-views')
          this.showPanelViews = true

        if (namePanel === 'panel-layers')
          this.showLayerPanel = true

        if (namePanel === 'panel-incidents' || namePanel === 'panel-statuses-progress') {
          this.isViewingOperationalStatuses = namePanel === 'panel-incidents';
          this.$refs.viewer.ShowOperationalStatuses(this.isViewingOperationalStatuses);
        }
      },

      _AllowedAction(action) {
        if (Object.keys(this.canActionsPictogram).length === 0)
          return false;

        return this.canActionsPictogram[action] === 'undefined' ? false : this.canActionsPictogram[action]
      },

      _HandleReturnClick(e) {
        if (this.subactivityId !== null) {
          this.$router.push( {name: 'subactivity.home', params: { subactivity_id: this.subactivityId, activity_id: this.activityId }})
        } else {
          this.$router.push({ name: 'activity.home', params: { activity_id: this.activityId }})
        }
      },

      _HandleClickInfoPictogram(e) {
        this.$refs.refInfoModal.show(this.pictogramId, this.displayPictogramLayer)
      },

      _HandleClickRegisterAdvance(e) {
        if (this.selectedEntities.length > 0) {
          const isObject = e && typeof e === 'object';

          const type = isObject ? e.type : e;
          const action = isObject ? e.action : 'register';

          // TODO: Aqui hay que mejorar el envio de datos si la accion es register se envia todo caso contrario
          // se envia solo el tipo de estado y los elementos seleccionados y estatuses
          const data = {
            action: action,
            title: isObject ? e.title : '',
            typeRegister: this.typeRegister,
            typeStatus: type,
            statuses: type === 'progress'
              ? this.workingPictogramLayer.statuses
              : this.workingPictogramLayer.incident_statuses,
            selectedEntities: this.selectedEntities,
            permittedStatuses: this.allowedStatuses[type],
            allowedSelectMultiple: this.allowedSelectMultiple[type] === "multiple" ? true : false,
            layer: this.workingPictogramLayer,
            designData: this.cadLayerDesign,
          }

          this.$refs.refUpdateStatusesModal.show(data)

        } else {
          this.$notify.info('no_elements_selected')
        }

      },
    },
}
</script>

<style scoped>
/* Ajustar el KonvaViewer para que use 100% de altura en lugar de 100vh */
:deep(.canvasContainer) {
  height: 100% !important;
}

/* Asegurar que el contenedor principal no cause scroll */
.relative.w-full {
  max-height: calc(100vh - 6rem);
  overflow: hidden;
}

.docking-panel {
  box-shadow: 1px 3px 10px 0 rgba(0,0,0,.4);
  -webkit-touch-callout: none;
  background: transparent;
  border: none;
  border-radius: 5px;
  overflow-x: hidden;
  overflow-y: hidden;
  position: absolute;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  z-index: 2;
}

.docking-panel-title {
  background-color: rgba(34,34,34,.94);
  border-bottom: 1px solid rgba(34,34,34,.8);
  color: #fff;

  border: none;
  border-radius: 5px 5px 0 0;
  cursor: move;
  font-size: 20px;
  font-weight: 300;
  line-height: 27px;
  overflow: hidden;
  padding: 11px 0 11px 14px;
  position: relative;
  resize: none;
  text-overflow: ellipsis;
  text-transform: capitalize;
  white-space: nowrap;
  z-index: 1;
}

.docking-panel-delimiter-shadow {
  box-shadow: 0 3px 5px 0 rgba(0,0,0,.1);
}

.docking-panel-close {
  background-position: 0 19px;
  background-repeat: no-repeat;
  cursor: pointer;
  height: 50px;
  position: absolute;
  right: 0;
  top: 0;
  width: 25px;
  z-index: 1;
}

.docking-panel-close {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNLjQ1NSAxMC45OTdhLjUuNSAwIDAgMS0uMzEtLjg1bDEwLTEwYS41MDIuNTAyIDAgMCAxIC43MS43MWwtMTAgMTBhLjUuNSAwIDAgMS0uNC4xNFoiIGZpbGw9IiM5NDk0OUYiLz48cGF0aCBkPSJNMTAuNDU3IDExLjAwN2EuNS41IDAgMCAxLS4zMS0uMTVsLTEwLTEwYS41MDIuNTAyIDAgMCAxIC43MS0uNzFsMTAgMTBhLjUuNSAwIDAgMS0uNC44NloiIGZpbGw9IiM5MzlDQTUiLz48L2c+PC9zdmc+);
}

.docking-panel-footer {
  background-color: #222;
}

.docking-panel-footer {
  bottom: 0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  height: 20px;
  left: 0;
  position: absolute;
  width: 100%;
}

.docking-panel-footer-resizer {
  background-position-x: 9px;
  background-position-y: 8px;
  background-repeat: no-repeat;
  bottom: 0;
  cursor: pointer;
  height: 20px;
  position: absolute;
  right: 0;
  width: 20px;
}

.docking-panel-footer-resizer {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+PHBhdGggZD0ibS41IDYuNSA2LTZNNC41IDYuNWwxLjUzNi0xLjUzNiIgc3Ryb2tlPSIjMDAwIi8+PHBhdGggZD0ibTEuNSA2LjUgNi02TTUuNSA2LjVsMS41MzYtMS41MzYiIHN0cm9rZT0iI0JFQzhEMiIvPjwvZz48L3N2Zz4=);
  background-position-x: 9px;
  background-position-y: 8px;
  background-repeat: no-repeat;
}

.layers-panel {
  border-color: transparent;
  height: 250px;
  left: 220px;
  min-height: 100px;
  min-width: 250px;
  top: 180px;
  width: 300px;
}

.pressed {
  background-color: rgb(51, 85, 136);
  color: white;
}

.not-pressed {
  background-color: rgba(85, 119, 187, 0.133);
  color: rgb(51, 85, 136);
}

</style>
